import { BrowserRouter, Routes, Route } from "react-router-dom";
import Chat from "./component/Chat/Chat.component";
import "bootstrap/dist/css/bootstrap.css";

function App() {
  const routes = [
    {
      path: "/",
      name: "chat",
      title: "chat",
      element: <Chat />,
    },
  ];

  const createRoutes = () => {
    const retData = routes.map((route, index) => {
      return route.element ? (
        <Route
          path={route.path}
          element={route.element}
          key={`page-route-${index}`}
        />
      ) : null;
    });
    return retData;
  };
  return (
    <>
      <BrowserRouter>
        <Routes>{createRoutes()}</Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
